import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { applyTheme, getInitialTheme, saveTheme, type Theme } from '../utils/theme';
type ThemeContextValue = {
  theme: Theme;
  toggleTheme: () => void;
};
const ThemeContext = createContext<ThemeContextValue | null>(null);
export function ThemeProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [theme, setTheme] = useState<Theme>(() => document.documentElement.classList.contains('dark') ? 'dark' : getInitialTheme());
  const toggleTheme = useCallback(() => {
    setTheme(current => {
      const next: Theme = current === 'dark' ? 'light' : 'dark';
      applyTheme(next, true);
      saveTheme(next);
      return next;
    });
  }, []);
  const value = useMemo(() => ({
    theme,
    toggleTheme
  }), [theme, toggleTheme]);
  return <ThemeContext.Provider value={value} data-id="element-676" data-mp="2fcbcsy875odq">{children}</ThemeContext.Provider>;
}
export function useTheme() {
  const ctx = useContext(ThemeContext);
  if (!ctx) throw new Error('useTheme must be used within ThemeProvider');
  return ctx;
}